import styles from './Portfolio.module.css';



import Project_1 from '../../images/projects/project_01.jpg';
import Project_2 from '../../images/projects/project_02.jpg';
import Project_3 from '../../images/projects/project_03.jpg';
import Project_4 from '../../images/projects/project_04.jpg';
import Project_5 from '../../images/projects/project_05.jpg';
import Project_6 from '../../images/projects/project_06.jpg';
import Project_7 from '../../images/projects/project_07.jpg';
import Project_8 from '../../images/projects/project_08.jpg';
import Project_9 from '../../images/projects/project_09.jpg';
import Project_10 from '../../images/projects/project_10.jpg';
import Project_11 from '../../images/projects/project_11.jpg';
import Project_12 from '../../images/projects/project_12.jpg';
import Project_13 from '../../images/projects/project_13.jpg';
import Project_14 from '../../images/projects/project_14.jpg';
import Project_15 from '../../images/projects/project_15.jpg';
import Project_16 from '../../images/projects/project_16.jpg';
import Project_17 from '../../images/projects/project_17.jpg';
import Project_18 from '../../images/projects/project_18.jpg';
import Project_19 from '../../images/projects/project_19.jpg';
import Project_20 from '../../images/projects/project_20.jpg';
import Project_21 from '../../images/projects/project_21.jpg';
import Project_22 from '../../images/projects/project_22.jpg';
import Project_23 from '../../images/projects/project_23.jpg';
import Project_24 from '../../images/projects/project_24.jpg';
import Project_25 from '../../images/projects/project_25.jpg';
import Project_26 from '../../images/projects/project_26.jpg';
import Project_27 from '../../images/projects/project_27.jpg';


import video_1 from '../../video/video-webm_01.webm';
import video_01 from '../../video/video-mp4_01.mp4';
import video_2 from '../../video/video-webm_02.webm';
import video_02 from '../../video/animation-mp4_02.mp4';
import video_3 from '../../video/video-webm_03.webm';
import video_03 from '../../video/video-mp4_03.mp4';
import video_4 from '../../video/video-webm_04.webm';
import video_04 from '../../video/bart-mp4_04.mp4';
import video_5 from '../../video/video-webm_05.webm';
import video_05 from '../../video/video-mp4_05.mp4';
import video_6 from '../../video/video-webm_06.webm';
import video_06 from '../../video/video-mp4_06.mp4';
import video_07 from '../../video/video-mp4_07.mp4';

const Portfolio = () => {
  return (
    <div className={styles.portfolio}>
      <div className={styles.container}>
        <h1 className={styles.title}>My portfolio</h1>

        <p className={`${styles.text} ${styles.textBottom}`}>Projects made in programm Blender</p>

        <ul className={styles.portfolioBox}>
          <li className={styles.pictures}>
            <p className={styles.text}>_01</p>
            <a                      
                href="https://illyashevchenko576.wixsite.com/portfolio"
                target="blank"
              >
              <img className={styles.picturesImg} src={Project_1} alt="project" />
              </a>
            <span className={styles.overlay}></span>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_02</p>
            <a                      
                href="https://illyashevchenko576.wixsite.com/portfolio"
                target="blank"
              >
              <img className={styles.picturesImg} src={Project_2} alt="project" />
              </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_03</p>
            <a                      
                href="https://www.instagram.com/p/CHAe4Vchwsx/"
                target="blank"
              >
              <img className={styles.picturesImg} src={Project_3} alt="project" />
            </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_04</p>
            <img className={styles.picturesImg} src={Project_4} alt="project" />
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_05</p>
             <a
                      
                      href="https://www.instagram.com/p/CG7cgVwhPbR/"
                      target="blank"
                    >
              <img className={styles.picturesImg} src={Project_5} alt="project" />
              </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_06</p>
            <a
                      
                      href="https://www.instagram.com/p/CIbO4CHh3w9/"
                      target="blank"
                    >
              <img className={styles.picturesImg} src={Project_6} alt="project" />
              </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_07</p>
            <a
                      
                      href="https://www.instagram.com/p/CIGjqXoh2H7/"
                      target="blank"
                    >
              <img className={styles.picturesImg} src={Project_7} alt="project" />
              </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_08</p>
            <a
                      
                      href="https://www.instagram.com/p/CGfF3jFAntq/"
                      target="blank"
                    >
              <img className={styles.picturesImg} src={Project_8} alt="project" />
              </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_09</p>
            <a
                      
                      href="https://www.instagram.com/p/CBNQwKNAho3/"
                      target="blank"
                    >
              <img className={styles.picturesImg} src={Project_9} alt="project" />
              </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_10</p>
            <a
                      
                      href="https://www.instagram.com/p/B_ovId2A3JG/"
                      target="blank"
                    >
              <img className={styles.picturesImg} src={Project_10} alt="project" />
              </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_11</p>
            <a
                      
                      href="https://www.instagram.com/p/B-aEwo-gYAI/"
                      target="blank"
                    >
              <img className={styles.picturesImg} src={Project_11} alt="project" />
              </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_12</p>
            <a                      
                href="https://www.instagram.com/p/B9FaKxRh3Zd/"
                target="blank"
              >
              <img className={styles.picturesImg} src={Project_12} alt="project" />
            </a>
          </li>

          {/* project_13 */}

          <li className={styles.pictures}>
            <p className={styles.text}>_13</p>
            <a                      
                href="https://www.instagram.com/p/B9FaKxRh3Zd/"
                target="blank"
              >
              <img className={styles.picturesImg} src={Project_13} alt="project" />
            </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_14</p>
            <a                      
                href="https://www.instagram.com/p/B9FaKxRh3Zd/"
                target="blank"
              >
              <img className={styles.picturesImg} src={Project_14} alt="project" />
            </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_15</p>
            <a                      
                href="https://www.instagram.com/p/B4Ki6oKgQRE/"
                target="blank"
              >
              <img className={styles.picturesImg} src={Project_15} alt="project" />
            </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_16</p>
            <a                      
                href="https://www.instagram.com/p/B9FaKxRh3Zd/"
                target="blank"
              >
              <img className={styles.picturesImg} src={Project_16} alt="project" />
            </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_17</p>
            <a                      
                href="https://www.instagram.com/p/CEJX2cKg1WV/"
                target="blank"
              >
              <img className={styles.picturesImg} src={Project_17} alt="project" />
            </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_18</p>
            <a                      
                href="https://www.instagram.com/p/B-XnBWogyJt/"
                target="blank"
              >
              <img className={styles.picturesImg} src={Project_18} alt="project" />
            </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_19</p>
            <a                      
                href="https://www.instagram.com/p/B66KXW9gNst/"
                target="blank"
              >
              <img className={styles.picturesImg} src={Project_19} alt="project" />
            </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_20</p>
            <a                      
                href="https://www.instagram.com/p/CErYG4IHicN/"
                target="blank"
              >
              <img className={styles.picturesImg} src={Project_20} alt="project" />
            </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_21</p>
            <a                      
                href="https://www.instagram.com/p/B_29YSQA6Ts/"
                target="blank"
              >
              <img className={styles.picturesImg} src={Project_21} alt="project" />
            </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_22</p>
            <a                      
                href="https://www.instagram.com/p/CEmt_B7A110/"
                target="blank"
              >
              <img className={styles.picturesImg} src={Project_22} alt="project" />
            </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_23</p>
            <a                      
                href="https://www.instagram.com/p/CAxCGQggStv/"
                target="blank"
              >
              <img className={styles.picturesImg} src={Project_23} alt="project" />
            </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_24</p>
            <a                      
                href="https://www.instagram.com/p/CEG3Hq4ATNH/"
                target="blank"
              >
              <img className={styles.picturesImg} src={Project_24} alt="project" />
            </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_25</p>
            <a                      
                href="https://illyashevchenko576.wixsite.com/portfolio"
                target="blank"
              >
              <img className={styles.picturesImg} src={Project_25} alt="project" />
            </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_26</p>
            <a                      
                href="https://illyashevchenko576.wixsite.com/portfolio"
                target="blank"
              >
              <img className={styles.picturesImg} src={Project_26} alt="project" />
            </a>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_27</p>
            <a                      
                href="https://illyashevchenko576.wixsite.com/portfolio"
                target="blank"
              >
              <img className={styles.picturesImg} src={Project_27} alt="project" />
            </a>
          </li>





          {/* video   */}

          <li className={styles.pictures}>
            <p className={styles.text}>_28</p>
            <a                      
                href="https://illyashevchenko576.wixsite.com/portfolio"
                target="blank"
              >
            <video
              autoPlay
              muted
              loop
              poster=""
              className={styles.video_item}
              controls
            >
              <source src={video_1} type="video/webm" />
              <source src={video_01} type="video/mp4" />
              </video>
              </a>
          </li>
          <li className={styles.pictures}>
            <p className={styles.text}>_29</p>
            <a
                      
                      href="https://www.instagram.com/p/B8l-64VgwFy/"
                      target="blank"
                    >
            <video
              autoPlay
              muted
              loop
              poster=""
              className={styles.video_item}
              controls
            >
              <source src={video_2} type="video/webm" />
              <source src={video_02} type="video/mp4" />
              </video>
              </a>
          </li>
          <li className={styles.pictures}>
            <p className={styles.text}>_30</p>
             <a                      
                href="https://illyashevchenko576.wixsite.com/portfolio"
                target="blank"
              >
            <video
              autoPlay
              muted
              loop
              poster=""
              className={styles.video_item}
              controls
            >
              <source src={video_3} type="video/webm" />
              <source src={video_03} type="video/mp4" />
              </video>
              </a>
          </li>
          <li className={styles.pictures}>
            <p className={styles.text}>_31</p>
            <video
              autoPlay
              muted
              loop
              poster=""
              className={styles.video_item}
              controls
            >
              <source src={video_4} type="video/webm" />
              <source src={video_04} type="video/mp4" />
            </video>
          </li>
          <li className={styles.pictures}>
            <p className={styles.text}>_32</p>
             
            <video
              autoPlay
              muted
              loop
              poster=""
              className={styles.video_item}
              controls
            >
              <source src={video_5} type="video/webm" />
              <source src={video_05} type="video/mp4" />
              </video>
              
          </li>
          <li className={styles.pictures}>
            <p className={styles.text}>_33</p>
            <video
              autoPlay
              muted
              loop
              poster=""
              className={styles.video_item}
              controls
            >
              <source src={video_6} type="video/webm" />
              <source src={video_06} type="video/mp4" />
            </video>
          </li>

          <li className={styles.pictures}>
            <p className={styles.text}>_34</p>
            <video
              autoPlay
              muted
              loop
              poster=""
              className={styles.video_item}
              controls
            >
              
              <source src={video_07} type="video/mp4" />
            </video>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Portfolio;
